var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ontology"},[_c('img',{ref:"cut",staticStyle:{"width":"100%","pointer-events":"none","vertical-align":"bottom"},attrs:{"src":_vm.imgHost+(_vm.editmsg.img||_vm.defaultimg),"alt":""}}),_c('div',{key:_vm.modekey,staticClass:"plate",attrs:{"id":_vm.modekey},on:{"mousedown":_vm.down,"mousemove":_vm.move,"mouseup":_vm.end}},_vm._l((_vm.editmsg.imglist),function(v,i){return _c('div',{key:i,staticClass:"mask",style:({
      top:v.marY+'%',
      left:v.marX+'%',
      width:v.width+'%',
      height:v.height+'%',
      border:'1px solid' +v.rgb,
      background:v.rgb,
    })},[(v.width&&v.height)?_c('div',{staticStyle:{"display":"block"}},[_vm._v("区域"+_vm._s(i+1))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }